const al = {
  roaming_screen_title: 'Roaming',
  roaming_settings_title: 'Konfigurimet Roaming',
  roaming_settings_description: 'Përpara se të udhëtosh, sigurohu që të kesh aktivizuar shërbimin Roaming në konfigurimet e celularit dhe konfigurimet e rrjetit',
  roaming_where_to_description: 'Sigurohu që të aktivizosh një paketë roaming të vlefshme në destinacionin ku do të udhëtosh',
  roaming_select_destination: 'Zgjidh destinacionin',
  romaing_select_prepaid: 'Me parapagesë/ Next',
  roaming_select_postpaid: 'Me kontratë/ Unlimited',
  roaming_explore_card_title: 'Në %1$s ti mund të aktivizosh paketën Roaming Travel Pack dhe të komunikosh lirshëm gjatë qëndrimit tënd',
  roaming_buy_plan: 'Aktivizo',
  roaming_bundles_title: 'Paketa',
  roaming_bundles_button_title: 'Paketat Roaming',
  roaming_more_info: 'Më shumë informacion',
  roaming_close: 'Mbyll',

  // Error
  roaming_get_recommandation_error: 'Kliko këtu per te provuar serish marrjen e rekomandimit',

  // Search Screen
  roaming_where_to: 'Ku do të udhëtosh?',
  roaming_search_country: 'Zgjidh destinacionin',
  roaming_search_description: 'Me Red Roaming mund të përdorësh planin tënd njësoj si në Shqipëri',

  // Country Roaming Screen
  roaming_country_to: 'Po udhëton në %1$s?',
  roaming_country_to_description: 'Shiko guidën tonë të udhëtimit me informacione të rëndësishme',
  roaming_calculator_offerCard: 'Mirësevini në %1$s. \n%1$s \n%1$s',
  roaming_calculator_yes_bundle: 'Në %1$s ti mund te përdorësh Roaming Explore Bundle. Zbulo më poshtë',
  roaming_calculator_no_bundle: 'Paketat Roaming nuk janë të aplikueshme në %1$s. Zbulo më poshtë tarifat standarde',
  roaming_learn_more: 'Më shumë',
  roaming_country_calculator_title: 'Tarifat Standarde',
  roaming_country_calculator_description: 'Nga Shqipëria në:',
  roaming_country_calculator_service_provider: 'Rrjeti partner që rekomandojmë është: %1$s',

  // Country Details Screen
  roaming_country_details_title: 'Informacione të nevojshme',
  roaming_country_details_currency: 'Monedha',
  roaming_country_details_capital: 'Kryeqyteti',
  roaming_country_details_prefix: 'Prefiksi',
  roaming_country_details_emergencySectionTitle: 'Numrat e Emergjencës',
  roaming_country_details_free_to_call: 'Telefonata është falas',

  // Embassies
  roaming_embassies_title: 'Ambasada',
  roaming_embassies_consulates_title: 'Konsullata',
  roaming_embassies_copy: 'Kopjo',
  roaming_embassies_copied: 'Kopjuar',
  roaming_embassies_call: 'Telefono',
  roaming_embassies_website: 'Website',
  roaming_embassies_phone_number: 'Numri i telefonit',
  roaming_embassies_working_hours: 'Orari',

  roaming_bundles_default_error: 'Dicka nuk funksionoi! Provo përsëri.',
  roaming_country_offers_subtitle: 'Më poshtë mund të aksesosh të gjitha paketat e disponueshme Roaming.'
}

export default al
